import * as React from 'react';
import {Layout} from '../../components/dashboard/layout';


const Directory = () => {

    return (

        <Layout>
            Directory page
        </Layout>
    )

}

export default Directory